import { render, staticRenderFns } from "./UserWisePacking.vue?vue&type=template&id=35e0dd58&"
import script from "./UserWisePacking.vue?vue&type=script&lang=js&"
export * from "./UserWisePacking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports